export enum IndirectTaxTaxLiabilityReportTab {
  UnitedStatesAndCanada = 'UNITED_STATES_AND_CANADA',
  EuropeanUnionAndUnitedKingdom = 'EUROPEAN_UNION_AND_UNITED_KINGDOM',
}

export const INDIRECT_TAX_LIABILITY_REPORT_TAB_LABELS: Record<
  IndirectTaxTaxLiabilityReportTab,
  string
> = {
  [IndirectTaxTaxLiabilityReportTab.UnitedStatesAndCanada]:
    'US & Canada',
  [IndirectTaxTaxLiabilityReportTab.EuropeanUnionAndUnitedKingdom]:
    'European Union & United Kingdom',
};
